import ApiService from "../../services/api.service"

const SkyShopService = {

	getSetting() {
		return ApiService.get(`/skyShop/getSkyShopInfo`)
	},
	saveSetting(data) {
		return ApiService.post(`/skyShop/save`, data)
	},
	getDocs(data) {
		return ApiService.post(`/warehouse-document/search/sky-chiqim`, data)
	},
	getBrigade() {
		return ApiService.get(`/brigade/list`)
	},
	saveBrigade(data, isCreate) {
		return ApiService.post(`/brigade/${isCreate?'create':'update'}`, data)
	},
	saveDoc(data) {
		return ApiService.post(`/warehouse-document/skyShop-edit-transfer/with-list`, data)
	},
	createDraftDoc(data) {
		return ApiService.post(`/warehouse-document/create-sky-shop`, data)
	},
	getEmployees(search) {
		return ApiService.get(`/employee/any/list/skyShop?search=${search}`)
	},
	getWhItems(search, depId) {
		return ApiService.get(`/item/sky-shop-search-for-dep/retail/${depId}?search=${search}`)
	},
	getDocById(id) {
		return ApiService.get(`/warehouse-document/get-sky-shop/${id}`)
	},
	getDocByIdForPos(id) {
		return ApiService.get(`/warehouse-document/get-sky-shop-with-post/${id}`)
	},
	deleteDoc(id) {
		return ApiService.delete(`/skyShop/delete/${id}`)
	},
	getDocList() {
		return ApiService.get(`/warehouse-document/documentBeforeReady`)
	},
	getItemsByDocId(id) {
		return ApiService.get(`/warehouse-document/whDocumentItemBeforeReady/${id}`)
	},
	saveReadyDoc(id) {
		return ApiService.post(`/warehouse-document/documentReady/${id}`)
	},
	getReportSales(id) {
		return ApiService.get(`/sale/listSaleByWgDocumentId/${id}`)
	},
	getSalePayments(id) {
		return ApiService.get(`/sale/paymentByWgDocumentId/${id}`)
	},
	getDocByIdForEdit(id) {
		return ApiService.get(`/wh-document-item/get-by-document-by-transfer/for-sky-shop/${id}`)
	},
	getReportEmployeeList(data) {
		return ApiService.post(`/skyShop/report/sky-shop/employee`, data)
	}

}

export default SkyShopService
